import script from "./goRinSyo0055.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0055.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0055.vue?vue&type=style&index=0&id=d16a0648&lang=scss"

const __exports__ = script;

export default __exports__